<template>
	<div>
		<h4 class="text-center">
			Территориальный справочник
		</h4>
		<table class="top-table">
			<thead>
				<tr>
					<th style='width: 20%;'>
						Субъект РФ
					</th>
					<th style='width: 20%;'>
						Лесничество
					</th>
					<th style='width: 20%;'>
						Участковое лесничество
					</th>
					<th>
						Урочище (дача)
					</th>
					<th v-if='showScrollWrap' style='width: 18px; padding:0;' rowspan="2"></th>
				</tr>
				<tr>
					<th>
						<TerritoryFilter field='region_name' :filter='filter'></TerritoryFilter>
					</th>
					<th>
						<TerritoryFilter field='forestry_name' :filter='filter'></TerritoryFilter>
					</th>
					<th>
						<TerritoryFilter field='localforestry_name' :filter='filter'></TerritoryFilter>
					</th>
					<th>
						<TerritoryFilter field='subforestry_name' :filter='filter'></TerritoryFilter>
					</th>
				</tr>
			</thead>
		</table>
		<div class="scroller-bottom">
			<table class="main-table">
				<tbody>
					<tr v-for='line in territory_journal'>
						<td>
							{{line.region_name}}
						</td>
						<td>
							{{line.forestry_name}}
						</td>
						<td>
							{{line.localforestry_name}}
						</td>
						<td>
							{{line.subforestry_name}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class='table_footer'>
			<div class='pull-left' style='position: absolute; margin: 20px 0 20px 0;'>
				<a class="btn btn-primary" :href='DBlink + "get_territory_journal_csv.php?where=" + compose_filter()'>Выгрузить</a>
				<button class="btn btn-info" @click='showEditTerritoryModal' v-if='$parent.canEditAddress'>Редактирование</button>
			</div>
			<div class="text-center">
				<ul class="pagination" v-if='pages'>
					<li :class='{ active: page.active }' v-for='page in pages'>
						<a v-if='isNumeric(page.num)' href='#' @click='select_page' :data-value='page.num'>{{page.num}}</a>
						<span v-else href='#' class="disabled_page">{{page.num}}</span>
					</li>
				</ul>
			</div>
		</div>

		<modal v-model="displayEditTerritory" :backdrop='false' effect="fade" medium class='modal-catalog'>
			<div slot="modal-header" class="modal-header">
			    <h3 class="modal-title">
			    	Редактирование справочника
			    </h3>
			  </div>
			<div>
				<edit-territory-catalog></edit-territory-catalog>
			</div>
			<div slot="modal-footer" class="modal-footer">
				<button type="button" class="btn btn-default" @click='hideEditTerritoryModal'>Закрыть</button>
			</div>
		</modal>
		<div class='loading-wrap' v-if='load_journal_status'>
			<i class='fa fa-spinner fa-spin' style='font-size:48px;'></i>
		</div>
	</div>
</template>

<script>

import {DB} from '@/constants'
import { EventBus } from '../../lib/EventBus'
import TerritoryFilter from './TerritoryFilter'
import editTerritoryCatalog from './editTerritoryCatalog'
import { modal} from 'vue-strap'

import '../../lib/css/fontawesome-all.min.css'

const GET_TERRITORY_JOURNAL = 'get_territory_journal.php'

const PADDING = 3
const ROWS_ON_PAGE = 50
const COLUMNS_COUNT = 4

export default {
	name: 'TerritoryCatalog',
	data () {
		return {
			territory_journal: [],
			pages: [],
			page_num: 1,

			filter: {
				region_name: [],
				forestry_name: [],
				localforestry_name: [],
				subforestry_name: [],
			},

			showScrollWrap: false,
			need_recalc_table: false,
			DBlink: DB,

			displayEditTerritory: false,

			load_journal_status: false
		}
	},
	components: {
		TerritoryFilter, editTerritoryCatalog, modal
	},
	methods: {
		showEditTerritoryModal () {
			this.displayEditTerritory = true
		},
		hideEditTerritoryModal () {
			this.displayEditTerritory = false
		},
		isNumeric (x) {
			return !Number.isNaN(+x)
		},
		compose_filter () {
			let where = '('
				for (let f in this.filter) {
					for (let i = 0; i < this.filter[f].length; i++) {
						if (f !== this.field)
							where += this.filter[f][i] !== '' ? `${f}='${this.filter[f][i]}' or ` : `${f} is null or `
					}
					if (f !== this.field) {
						where = this.filter[f].length !== 0 ? where.slice(0,-4) : where
						where += this.filter[f].length !== 0 ? ') and (' : ''
					}
					
				}

				let where_range = [] 
				for (let f in this.filterRange) {
					let filter_name = f
					if(filter_name == 'forest_age')
						filter_name = 'forest_age::int'
					if(this.filterRange[f].min)
						where_range.push(`${filter_name} >= ${this.filterRange[f].min}`)
					if(this.filterRange[f].max)
						where_range.push(`${filter_name} <= ${this.filterRange[f].max}`)					
				}

				const joined = where_range.join(' and ')
				where = where.slice(0,-6)
				if(where)
				{
					if(joined)
						where = where + ' and ' + joined
				} else 
				{
					if(joined)
						where = joined
				}
				return where
		},
		filter_journal (drop_page_num = true) {
			if(drop_page_num)
				this.page_num = 1

			//console.warn(where)

			this.load_journal_status = true

			let data = new FormData()
			data.append('start_num', (this.page_num - 1) * ROWS_ON_PAGE + 1)
			data.append('show_count', ROWS_ON_PAGE)

			data.append('where', this.compose_filter())

			fetch(DB + GET_TERRITORY_JOURNAL, {
					method: 'POST',
					body: data,
					credentials: 'include'
			})
			.then(res => res.json())
			.then(res => {
				this.locations_count = res[res.length - 1].count
				this.pages_count = Math.ceil(res[res.length - 1].count / ROWS_ON_PAGE)
				res.length--
				
				this.fill_pages()

				this.territory_journal = res
				this.load_journal_status = false
				this.need_recalc_table = true
			})
		},
		fill_pages () {
			//debugger
			let temp_pages = []

			if(this.page_num - 2 > PADDING)
			{
				temp_pages.push({active: false, num: 1})
				temp_pages.push({active: false, num: '...'})
			}
			if(this.page_num - 2 == PADDING)
			{
				temp_pages.push({active: false, num: 1})
			}

			for (let i = this.page_num - PADDING - 1; i < this.page_num + PADDING; i++)
				if(i >= 0 && i < this.pages_count)
					temp_pages.push({active: false, num: i + 1})

			if(this.page_num < this.pages_count - PADDING - 1)
			{
				temp_pages.push({active: false, num: '...'})
				temp_pages.push({active: false, num: this.pages_count})
			}
			if(this.page_num == this.pages_count - PADDING - 1)
			{
				temp_pages.push({active: false, num: this.pages_count})
			}

			this.pages = temp_pages

			this.pages.forEach(p => {
				p.active = (p.num == this.page_num)
			})
		},
		select_page (e) {
			let value = e
			if(!this.isNumeric(value)) 
				value = +e.target.getAttribute('data-value')

			this.page_num = value
			this.filter_journal(false)
			this.fill_pages()
		}
	},
	updated () {
		this.$nextTick(() => {
			if(this.need_recalc_table)
		    {
		    	const scrollBlock = document.querySelector('.scroller-bottom')
		    	const newShowScrollWrap = Boolean(scrollBlock.scrollHeight > scrollBlock.clientHeight)
		    	if(newShowScrollWrap != this.showScrollWrap)
		    	{
		    		this.showScrollWrap = newShowScrollWrap
		    		return
		    	}
		    	//this.showScrollWrap = 

		    	for(let i = 1; i <= COLUMNS_COUNT; i++)
		    	{
		    		if(document.querySelector('.main-table td:nth-child(' + i + ')'))
		    			document.querySelector('.main-table td:nth-child(' + i + ')').style.width = document.querySelector('.top-table th:nth-child(' + i + ')').offsetWidth + 'px'
		    	}

		    	this.need_recalc_table = false	    	
		    }
		})
	},
	mounted() {
		this.filter_journal()

		EventBus.$on('territory_filter', f => {
			this.filter[f.field] = f.value !== '' ? f.value : null
			this.filter_journal()
		})
	},
	beforeDestroy () {
		EventBus.$off('territory_filter')
	} 
}

</script>

<style scoped>
	.scroller-bottom {
		margin: 0;
		height: calc(100vh - 245px);
    	min-height: 580px;
    	width: 100%;
    	border: 1px solid #ccc;
    	border-radius: 2px;
    	border-top: none;
    	overflow-x: auto;
	}

	table th {
		border: 1px solid black;
	}

	table {
		table-layout: auto;
		width: 100%;
	}

	table tr:first-child th {
		text-align: center;
		vertical-align: middle;
		height: 24px;
		padding: 0 10px 0 10px;
	}

	table td {
		padding: 4px 8px;
		border: 1px solid #bbb;
		text-align: center;
	}

	.loading-wrap {
		position: absolute;
		left: 0;
		right: 0;
		z-index: 1000;
		top: 0;
		bottom: 0;
		background: rgba(255,255,255,0.8);
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>


// WEBPACK FOOTER //
// TerritoryCatalog.vue?4ecfdfa7